"use client";

import { c as _c } from "react/compiler-runtime";
import { getTierTheme } from "../../utils/tier-colors";
interface TierConfig {
  id: string;
  label: string;
  points: number;
}
interface HeroBannerProps {
  points: number;
  currentTier: string;
  tierConfigs: TierConfig[];
  labels: Record<string, string>;
}
export default function HeroBanner(t0) {
  const $ = _c(66);
  const {
    points,
    currentTier,
    tierConfigs,
    labels
  } = t0;
  let t1;
  if ($[0] !== currentTier) {
    t1 = getTierTheme(currentTier);
    $[0] = currentTier;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const theme = t1;
  let isMaxTier;
  let nextTierConfig;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== currentTier || $[3] !== labels.currentTier || $[4] !== labels.maxTierReached || $[5] !== labels.points || $[6] !== labels.tierProgress || $[7] !== points || $[8] !== theme.gradient || $[9] !== theme.icon || $[10] !== tierConfigs) {
    const sorted = [...tierConfigs].sort(_temp);
    let t10;
    if ($[21] !== currentTier) {
      t10 = t => t.id === currentTier;
      $[21] = currentTier;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    const currentIndex = sorted.findIndex(t10);
    const currentTierConfig = sorted[currentIndex];
    nextTierConfig = currentIndex >= 0 && currentIndex < sorted.length - 1 ? sorted[currentIndex + 1] : null;
    isMaxTier = !nextTierConfig;
    const currentThreshold = currentTierConfig?.points ?? 0;
    const nextThreshold = nextTierConfig?.points ?? currentThreshold;
    const rangeTotal = nextThreshold - currentThreshold;
    const progress = isMaxTier ? 100 : rangeTotal > 0 ? Math.min((points - currentThreshold) / rangeTotal * 100, 100) : 100;
    const maxPoints = sorted.length > 0 ? sorted[sorted.length - 1].points : 0;
    t9 = `bg-gradient-to-r ${theme.gradient} rounded-lg border border-border p-6 md:p-8`;
    t7 = "flex flex-col gap-6";
    let t11;
    if ($[23] !== labels.currentTier) {
      t11 = <p className="text-sm font-medium text-muted-foreground">{labels.currentTier}</p>;
      $[23] = labels.currentTier;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    let t12;
    if ($[25] !== theme.icon) {
      t12 = <span className="mr-2">{theme.icon}</span>;
      $[25] = theme.icon;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    const t13 = <div>{t11}<h2 className="text-2xl font-bold text-foreground md:text-3xl">{t12}{currentTierConfig?.label ?? currentTier}</h2></div>;
    let t14;
    if ($[27] !== labels.points) {
      t14 = <p className="text-sm font-medium text-muted-foreground">{labels.points}</p>;
      $[27] = labels.points;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== points) {
      t15 = points.toLocaleString();
      $[29] = points;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    let t16;
    if ($[31] !== t15) {
      t16 = <p className="text-4xl font-extrabold text-primary md:text-5xl">{t15}</p>;
      $[31] = t15;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    let t17;
    if ($[33] !== t14 || $[34] !== t16) {
      t17 = <div>{t14}{t16}</div>;
      $[33] = t14;
      $[34] = t16;
      $[35] = t17;
    } else {
      t17 = $[35];
    }
    if ($[36] !== t13 || $[37] !== t17) {
      t8 = <div className="flex flex-col items-center gap-2 text-center md:flex-row md:justify-between md:text-left">{t13}{t17}</div>;
      $[36] = t13;
      $[37] = t17;
      $[38] = t8;
    } else {
      t8 = $[38];
    }
    t5 = "flex flex-col gap-3";
    let t18;
    if ($[39] !== labels.tierProgress) {
      t18 = <span>{labels.tierProgress}</span>;
      $[39] = labels.tierProgress;
      $[40] = t18;
    } else {
      t18 = $[40];
    }
    const t19 = isMaxTier ? <span className="font-semibold text-primary">{labels.maxTierReached}</span> : <span>{points.toLocaleString()} / {nextThreshold.toLocaleString()} {labels.points}</span>;
    if ($[41] !== t18 || $[42] !== t19) {
      t6 = <div className="flex items-center justify-between text-sm text-muted-foreground">{t18}{t19}</div>;
      $[41] = t18;
      $[42] = t19;
      $[43] = t6;
    } else {
      t6 = $[43];
    }
    t2 = "relative h-3 w-full overflow-hidden rounded-full bg-muted";
    const t20 = `${progress}%`;
    if ($[44] !== t20) {
      t3 = <div className="h-full rounded-full bg-primary transition-all duration-500 ease-out" style={{
        width: t20
      }} />;
      $[44] = t20;
      $[45] = t3;
    } else {
      t3 = $[45];
    }
    t4 = maxPoints > 0 && sorted.map(tier => {
      const position = tier.points / maxPoints * 100;
      const earned = points >= tier.points;
      return <div key={tier.id} className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2" style={{
        left: `${position}%`
      }} title={`${tier.label}: ${tier.points.toLocaleString()} pts`}><div className={`h-4 w-4 rounded-full border-2 ${earned ? "border-primary bg-primary" : "border-muted-foreground bg-card"}`} /></div>;
    });
    $[2] = currentTier;
    $[3] = labels.currentTier;
    $[4] = labels.maxTierReached;
    $[5] = labels.points;
    $[6] = labels.tierProgress;
    $[7] = points;
    $[8] = theme.gradient;
    $[9] = theme.icon;
    $[10] = tierConfigs;
    $[11] = isMaxTier;
    $[12] = nextTierConfig;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    isMaxTier = $[11];
    nextTierConfig = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[46] !== t2 || $[47] !== t3 || $[48] !== t4) {
    t10 = <div className={t2}>{t3}{t4}</div>;
    $[46] = t2;
    $[47] = t3;
    $[48] = t4;
    $[49] = t10;
  } else {
    t10 = $[49];
  }
  let t11;
  if ($[50] !== isMaxTier || $[51] !== labels.nextTier || $[52] !== nextTierConfig) {
    t11 = !isMaxTier && nextTierConfig && <p className="text-center text-sm text-muted-foreground">{labels.nextTier}: <span className="font-semibold text-foreground">{nextTierConfig.label}</span></p>;
    $[50] = isMaxTier;
    $[51] = labels.nextTier;
    $[52] = nextTierConfig;
    $[53] = t11;
  } else {
    t11 = $[53];
  }
  let t12;
  if ($[54] !== t10 || $[55] !== t11 || $[56] !== t5 || $[57] !== t6) {
    t12 = <div className={t5}>{t6}{t10}{t11}</div>;
    $[54] = t10;
    $[55] = t11;
    $[56] = t5;
    $[57] = t6;
    $[58] = t12;
  } else {
    t12 = $[58];
  }
  let t13;
  if ($[59] !== t12 || $[60] !== t7 || $[61] !== t8) {
    t13 = <div className={t7}>{t8}{t12}</div>;
    $[59] = t12;
    $[60] = t7;
    $[61] = t8;
    $[62] = t13;
  } else {
    t13 = $[62];
  }
  let t14;
  if ($[63] !== t13 || $[64] !== t9) {
    t14 = <div className={t9}>{t13}</div>;
    $[63] = t13;
    $[64] = t9;
    $[65] = t14;
  } else {
    t14 = $[65];
  }
  return t14;
}
function _temp(a, b) {
  return a.points - b.points;
}